import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { NGO_COMMUNITIES_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateNGO from './components/CreateNGO/CreateNGO';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityAssessmentNGO from './interfaces/IMaterialityAssessmentNGO';

import styles from './scss/MaterialityAssessmentNGO.module.scss';

function MaterialityAssessmentNGOView({
  isEmptyList, loading, addStakeholder, goBack, goToNextMaterialityAssessment, openModal,
  itemNgo, onEditRecord, onLoadMore, hasMore, onDeleteItem,
  selectedItem, recordId, currentId, setOpenModal, setItemNGO, vcmName, vcmId, isViewOnly = false,
}: IMaterialityAssessmentNGO) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantNGOs')}
            buttonTitle={t('materialityAssessment.addNGO')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyNGODescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {itemNgo.length > 0 && (
                  <ItemsTable
                    items={itemNgo}
                    headCells={NGO_COMMUNITIES_CELLS}
                    onEditRecord={onEditRecord}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={loading}
                    onDeleteItem={onDeleteItem}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CreateNGO
        open={openModal}
        onClose={addStakeholder}
        title={t('materialityAssessment.addNGO')}
        selectedItem={selectedItem}
        recordId={recordId}
        currentId={currentId}
        setOpenModal={setOpenModal}
        setItemNGO={setItemNGO}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentNGOView;
